/**
 *
 * RadioField
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { StyledRadioGroup, StyledRadio } from "./styles";

/* eslint-disable react/prefer-stateless-function */
export function RenderRadio(props) {
  const {
    field,
    options,
  } = props;

  return (
    <FormGroup>
      <StyledRadioGroup {...field}>
        {options.map(option => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<StyledRadio color="primary" />}
            label={option.label}
          />
        ))}
      </StyledRadioGroup>
    </FormGroup>
  );
}

const normalizeBoolean = value => {
  if (value === "true") {
    return true;
  }

  if (value === "false") {
    return false;
  }

  return value;
};

RenderRadio.propTypes = {
  options: PropTypes.array,
  field: PropTypes.object,
  form: PropTypes.object,
  handleOnChange: PropTypes.func
};

const RadioField = props => (
  <Field component={RenderRadio} {...props} normalize={normalizeBoolean} />
);

RadioField.propTypes = {
  options: PropTypes.array
};

export default RadioField;
